import Component from '../abstracts/Component';
import queryString from 'query-string';
import Observer from '../utils/ObserverIntersection';
import { replacePageInHistory } from '../utils/BrowserHistoryUtils';

export default class InfiniteScrollLogic extends Component {
  get SELECTORS() {
    return {
      main: '[data-infinite-scroll]',
      resultContainer: '.js-filters-result',
      footer: '.footer-main',
    };
  }

  constructor() {
    super();
    const searchObj = queryString.parse(location.search);
    const preload = searchObj.preload;
    const page = parseInt(searchObj.page);
    this.wasPreloaded = preload || page>0 || false;
    this.startPage = this.wasPreloaded ? page + 1 : 1;
    this.footerOffset = this.getFooterOffset();
  }

  getFooterOffset() {
    const scrollElement = document.querySelector(this.SELECTORS.main);
    const footerElement = document.querySelector(this.SELECTORS.footer);
    if ( scrollElement == null || footerElement == null) return false; // remember the check...
    const scrollRect = scrollElement.getBoundingClientRect();
    const footerRect = footerElement.getBoundingClientRect();

    const pixel = Math.abs(footerRect.top - scrollRect.bottom);

    if (isNaN(pixel) || !pixel || pixel == 0) {
      return 400;
    } else {
      return pixel;
    }
  }

  observeScroll() {
    this.internalObserveScroll();
  }

  internalObserveScroll() {
    this.scroolObserver = new Observer('.footer-main', this.footerOffset, null, (entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          let lastPage = document.querySelector(this.SELECTORS.main).dataset.infiniteScrollLastpage;
          let query = document.querySelector(this.SELECTORS.main).dataset.infiniteScrollQuery;
          let parsedQueryPage = queryString.parse(query).page;
          if (parseFloat(parsedQueryPage) <= parseFloat(lastPage)) {
            this.getPaginatedResult(query);
          } else {
            observer.unobserve(entry.target);
          }
        }
      });
    });
  }

  getPaginatedResult(query) {
    $.ajax({
      type: 'GET',
      url: query
    }).then(res => {
      let newURL = query.replace("isRefineSearch=true", "isRefineSearch=false");
      replacePageInHistory(newURL.replace(/\s.*/, ""),{},"", true);

      let response = new DOMParser().parseFromString(res, 'text/html').querySelector(this.SELECTORS.resultContainer);
      let container = document.querySelector(this.SELECTORS.resultContainer);
      let rows = response.querySelectorAll('.js-products-row');
      console.debug('loaded', rows.length, 'rows');

      for(let child of rows) {
        container.appendChild(child);
      }
      this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.animation);
      this.enhancePage();
    }).fail(() => {
      console.log('getPaginatedResult() fail');
    });
  }

  replaceButton(button, hide) {
    return new Promise((resolve, reject) => {
      try {
        let mainParent = document.querySelector(this.SELECTORS.main).parentElement;
        let query = document.querySelector(this.SELECTORS.main).dataset.infiniteScrollQuery;
        let newButton = null;
        if (button) {
          mainParent.innerHTML = button;
          newButton = document.querySelector(this.SELECTORS.main);
          newButton.setAttribute('data-infinite-scroll-query', query);
          mainParent.style.display = hide ? 'none' : '';
        }
        resolve(true)
      } catch (e) {
        reject(e)
      }
    });
  }

  enhancePage() {
    const main = document.querySelector(this.SELECTORS.main);
    let parsedQuery = queryString.parse(document.querySelector(this.SELECTORS.main).dataset.infiniteScrollQuery);
    parsedQuery.page = parseFloat(parsedQuery.page) + 1;
    main.setAttribute('data-infinite-scroll-query', `?${queryString.stringify(parsedQuery)}`);
  }

  setBaseQueryValue(query) {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        main.setAttribute('data-infinite-scroll-query', query);
        resolve(true)
      } catch (e) {
        console.debug(e);
        reject(false);
      }
    });
  }

  bindEvents() {
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({
      event,
      payload
    }) => {
      if (payload.query) this.setBaseQueryValue(payload.query).then(res => {
        if(!payload.skipScroll) {
          this.observeScroll();
        }
      });
      this.replaceButton(payload.updatedButton, payload.hideButton).then(res => {
        this.bindClickOnce();
      });
    });
    this.bindClickOnce();
  }

  bindClickOnce() {
    this.$one('click.is', ({
      event
    }) => {
      event.currentTarget.classList.add('d-none');

      this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {
        page: this.startPage
      });
    }, this.SELECTORS.main);
  }

  render() {
    this.log('Load logics...');
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }
}
